import { render } from "./blessing.vue?vue&type=template&id=79499acd&scoped=true"
import script from "./blessing.vue?vue&type=script&lang=js"
export * from "./blessing.vue?vue&type=script&lang=js"

import "./blessing.vue?vue&type=style&index=0&id=79499acd&scoped=true&lang=css"

import exportComponent from "/home/isa/qrcode-activity/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79499acd"]])

export default __exports__